import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";

const { persistAtom } = recoilPersist({
  key: "Yvooa-Core",
  storage: sessionStorage,
});

export const maintenanceTechId = atom({
  key: "maintenanceTechId",
  default: "",
  effects_UNSTABLE: [persistAtom],
});

export const maintenanceTechTableStateAtom = atom({
  key: "maintenanceTechTableState",
  default: { search: "", searchOpen: false, page: 0, serviceType: "All" },
});

export const maintenanceDashboardStateAtom = atom({
  key: "maintenanceDashboardState",
  default: {
    filters: {
      portfolio: "",
      property: "",
      priority: "",
      category: "",
      vendor: "",
      status: "",
      fromDate: "",
      toDate: "",
      widget: "All Requests",
    },
    stagedAdvancedFilters: {
      portfolio: "",
      property: "",
      priority: "",
      category: "",
      vendor: "",
      status: "",
      widget: "All Requests",
    },
    commonReportBuilderValues: { startDate: "", endDate: "" },
    reportPeriod: "All",
    searchQuery: "",
    activeMaintenance: "workOrders",
    isCollapsed: false,
  },
});
